import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://yjcmsjgwrbcsjqnplugm.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlqY21zamd3cmJjc2pxbnBsdWdtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwODIyOTAsImV4cCI6MjA5NjY1ODI5MH0.6hDrW5ztMf3Duu6Oy_rNJqk1_hHz1PLlLOZYoATCxSw'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})